import * as actionTypes from "./actionTypes";
// import { bannerData } from "../../data";
import {firebase} from "../../firebase/index";
import {collections,constants,documents} from "../../firebase/firestoreNameSpaces"
import {generateUniqueId,uploadImage,deleteFileFromUrl, shuffleArray} from "../utility"

export const fetchClients = () => {
  return async (dispatch) => {
     
  
    try{
      dispatch({ type: actionTypes.FETCH_CLIENTS, payload: { loading: true } });
      let db = firebase.firestore();
      let data = (await db.collection(collections.K5METADATA).doc(documents.CLIENTS).get()).data();

      let clients = [];
        for(let id in data){
            clients.push(data[id])
        }
       
      dispatch({
        type: actionTypes.FETCH_CLIENTS,
        payload: { clientData: clients, loading: false },
      });
  }catch(error){
      dispatch({
        type: actionTypes.FETCH_CLIENTS,
        payload: { clientData: null, loading: false },
      });
    //   return alert(error)
  }

  };
};

export const onAddClient = (client) => {
  return async (dispatch,getState) => {
    dispatch({
      type: actionTypes.CLIENT_CONTROLS,
      payload: { addBtnLoading: true },
    });
   

    try{  
      let clients = getState().client.clientData;
      let clientData = [];
      dispatch({
        type: actionTypes.CLIENT_CONTROLS,
        payload: { addBtnLoading: true },
      });
      let image = client.imgUrl;
      let {imgTitle,redirectUrl}  = client;
      //###########
      let path = `client/${generateUniqueId(6)}${image.name}`
      let url =  await uploadImage(path,image);
      let id = generateUniqueId(10)
      let clientObj = {id:id,imgUrl:url,redirectUrl:redirectUrl,imgTitle:imgTitle}
      let db = firebase.firestore();
      await db.collection(collections.K5METADATA).doc(documents.CLIENTS)
      .set({[id]:clientObj},{merge:true})
      if(clients.length){
          clientData = [...clients,clientObj]
      }else{
        clientData.push(clientObj)
      }
        dispatch({
          type: actionTypes.CLIENT_CONTROLS,
          payload: { addBtnLoading: false ,clientData:clientData},
        });
        // window.location.reload()
      return alert("Client Added Successfully")
  }catch(error){
    dispatch({
      type: actionTypes.CLIENT_CONTROLS,
      payload: { addBtnLoading: false },
    });
      return alert(error)
  }

  };
};
export const onEditClient = (editedclient, oldclientArray) => {
  return async (dispatch) => {
  
    try{
      dispatch({
        type: actionTypes.CLIENT_CONTROLS,
        payload: { clientBtnLoading: true },
      }); 
    
      let id = editedclient.id;
      let db = firebase.firestore();
      let clients = (await db.collection(collections.K5METADATA).doc(documents.CLIENTS).get()).data();
      for (let ckey in clients) {
        if (
          ckey != id &&
          clients[ckey].imgTitle == editedclient.imgTitle
        ) {
          dispatch({
            type: actionTypes.CLIENT_CONTROLS,
            payload: { clientBtnLoading: false },
          }); 
          return alert(
            "Image Title already exists. Please Select Different Image Title"
          );
        }
      }
      if(editedclient.image){
        let path = `client/${generateUniqueId(6)}${editedclient.image.name}`
        let url =  await uploadImage(path, editedclient.image);
        await deleteFileFromUrl(editedclient.imgUrl)
        editedclient.imgUrl = url;
        delete editedclient["image"]
      }
     await db.collection(collections.K5METADATA).doc(documents.CLIENTS)
      .set({[id]:editedclient},{merge:true})
      dispatch({
        type: actionTypes.CLIENT_CONTROLS,
        payload: { clientBtnLoading: false },
      });
      window.location.reload()
    }catch(error){

      dispatch({
        type: actionTypes.CLIENT_CONTROLS,
        payload: { clientBtnLoading: false },
      });
      return alert(error)
    }

  };
};
export const onDeleteClient = (client) => {
  return async (dispatch,getState) => {
   
    
    try{
      let clients = getState().client.clientData;
      dispatch({
        type: actionTypes.CLIENT_CONTROLS,
        payload: { deleteBtnLoading: true },
      });
      
      //########
      let db = firebase.firestore();
      await db.collection(collections.K5METADATA).doc(documents.CLIENTS).set({[client.id]:firebase.firestore.FieldValue.delete()},{merge:true})
      await deleteFileFromUrl(client.imgUrl);
      document.getElementById(`cpd${client.id}`).click()
      dispatch({
        type: actionTypes.CLIENT_CONTROLS,
        payload: { deleteBtnLoading: false,clientData:clients.filter(ca=>ca.id!=client.id) },
      });
      return alert("Client Deleted Successfully")
  }catch(error){
    dispatch({
      type: actionTypes.CLIENT_CONTROLS,
      payload: { deleteBtnLoading: false },
    });
      return alert(error)
  }

  };
};
